import React, { useState, useEffect } from 'react';
import './ThumbnailLoading.css';
import '../../styles/shimmer-animations.css';

export const ThumbnailLoading = ({
    className = '',
    iconName = null
}) => {
    const [iconNameProcessed, setIconNameProcessed] = useState('');

    const randomLoaderIcons = [
        'clubs',
        'diamonds',
        'spades',
        'hearts',
    ];

    useEffect(() => {
        // if iconName not passed - choose random icon from the list
        setIconNameProcessed(!iconName ? getRandomIcon(randomLoaderIcons) : iconName);

        function getRandomIcon(randomLoaderIcons = []) {
            return randomLoaderIcons[Math.floor(
                Math.random() * randomLoaderIcons.length
            )];
        }
    }, [iconName]);

    return (
        <div className={`${className} game-img-loading`}>
            <div className={`game-img-loading__icon game-img-loading__icon--${iconNameProcessed}`} />
            <div className="game-img-loading__gradient" />
        </div>
    );
};
